import LadderLocalStorage from '../../../utilities/LadderLocalStorage';
import { AREAS, KINDS } from './releases.js';

/**
 * Which "What's new" notes a user has still to read. Versions compare as strings (see releases.js),
 * and a null version is a user who has read none.
 */

/** The later of two versions, either of which may be null. */
export function laterVersion(a, b) {
	if(!a) {
		return b || null;
	}
	if(!b) {
		return a;
	}
	return a > b ? a : b;
}

/** The notes after `seen`, newest first. */
export function unseenReleases(releases, seen) {
	return sortedReleases(releases).filter((release) => !seen || release.version > seen);
}

export function sortedReleases(releases) {
	return releases.slice().sort((a, b) => (a.version < b.version ? 1 : (a.version > b.version ? -1 : 0)));
}

export function latestVersion(releases) {
	return releases.reduce((latest, release) => laterVersion(latest, release.version), null);
}

/**
 * A release's changes by area and then kind, each in the order AREAS and KINDS list them, leaving
 * out the empty ones: [{ area, label, icon, kinds: [{ kind, label, changes }] }].
 */
export function groupChanges(release) {
	return Object.keys(AREAS)
		.map((area) => ({
			area,
			...AREAS[area],
			kinds: Object.keys(KINDS)
				.map((kind) => ({
					kind,
					...KINDS[kind],
					changes: release.changes.filter((change) => change.area === area && change.kind === kind),
				}))
				.filter((group) => group.changes.length > 0),
		}))
		.filter((group) => group.kinds.length > 0);
}

/**
 * The version this browser last marked read for the user. The server's copy is the one that counts;
 * this covers the player the service worker hands over from its cache on the next load, which can
 * predate the read and would show the notes a second time.
 */
export function readLocalSeen(userId) {
	if(!userId) {
		return null;
	}
	try {
		return LadderLocalStorage.getItem(localKey(userId), null);
	} catch(error) {
		return null;
	}
}

export function writeLocalSeen(userId, version) {
	try {
		LadderLocalStorage.setItem(localKey(userId), version);
	} catch(error) {
		// The server has it too.
	}
}

function localKey(userId) {
	return `whatsNewSeen:${userId}`;
}
